export const data = {
  description:
    "Su socio estratégico en la cadena de suministro global, ofreciendo soluciones logísticas y de carga profesionales, eficientes y confiables.",
  address:
    "Dirección: Av. Balboa, Torre BAC, piso 13, oficina 2 Panamá, Panama City, Panama 0831",
  quick: "Enlaces Rápidos",
  aboutUs: "Sobre Nosotros",
  services: "Servicios",
  contactUs: "Contáctenos",

  maritimeLaw: "Derecho Marítimo",
  taxLaw: "Derecho Tributario",
  customsLaw: "Derecho Aduanero",
  commercialLaw: "Derecho Comercial",
  insurance: "Seguros",
  administrativeProcesses: "Procesos Administrativos",
  stsOperations: "Operaciones STS",

  community: "Comunidad",
  privacyPolicy: "Política de Privacidad",
  termsAndConditions: "Términos & Condiciones",
};
